import { catchAllPageRoutes, pageRoutes } from './routing'

export const dateFormats = {
  YEAR_MONTH_DAY_FORMAT: 'yyyy-MM-dd', // 2021-3-27
  MONTH_DAY_YEAR_FORMAT: 'MM-dd-yyyy', // 12-24-2021
  MONTH_DAY_YEAR_SLASH_FORMAT: 'MM/dd/yyyy', // 12/24/2021
  DAY_FORMAT: 'E', // Mon
  FULL_DAY_FORMAT: 'EEEE', //Monday
  MONTH_DAY_FORMAT: 'LLL do', // Feb 24th
  MONTH_DATE_FORMAT: 'LLL dd', //Feb 05
  MONTH_DATE_SINGLEDIGIT_FORMAT: 'LLL d', // Feb 5 or Feb 13
  WEEKDAY_MONTH_DAY_FORMAT: 'E, LLL do', //MON, Feb 24th
  FULL_WEEKDAY_MONTH_DAY_FORMAT: 'EEEE, LLLL d', //Monday, February 5
  FULL_WEEKDAY_MONTH_DAY_YEAR_FORMAT: 'EEEE LLL d, yyyy', // Monday, February 5 2023
  TIME_FORMAT: 'p', // 12:00 PM
  TIME_FORMAT_LOWER: 'h:mm aaa', // 12:00 pm
  DATE_TIME_FORMAT: 'MM/dd/yyyy — p', // 3/27/2021 - 11:04AM
  DAY_MONTH_YEAR: 'dd/MM/yyyy',
  DAY_MONTHNAME_YEAR_FORMAT: `do LLL yyyy`, //22nd Jan 2020
  SHORT_TIMEZONE: 'z', // PDT || GMT-4 depending on the location
  TIME_WITH_TIMEZONE: 'p z', //10am PDT || 10am GMT+530
  TIME_WITH_TIMEZONE_LOWER: 'h:mmaaa z', //10am PDT || 10am GMT+530
  MONTH_DAY_YEAR_DOB_FORMAT: 'MM/dd/yyyy',
  DAY_DATE_MONTH_FORMAT: 'E, do LLL', // Sat, 24th Dec
  WEEKDAY_SEPARATOR_MONTH_DAY_FORMAT: 'E | LLL do', //MON | Feb 24th
  MONTHNAME_SEPERATOR_DAY_YEAR_FORMAT: 'LLL, dd yyyy', //Feb, 24 2021
  MONTHNAME_DAY_SEPERATOR_YEAR_FORMAT: 'LLL dd, yyyy', //Feb 24, 2021
  DAY_MONTH_TIME_FORMAT: 'E LLL dd, h:mmaaa', //Fri Sep 15, 4:00pm
}

export const COOKIE_KEYS = {
  VISITED_FIRST_TIME_FLOW: 'VISITED_FIRST_TIME_FLOW',
  SUPERADMIN_DATA: 'SUPERADMIN_DATA',
  USER: 'user',
  ACCESS_TOKEN: 'access_token',
  SKIP_EMAIL_ACCESS_TOKEN: 'skip_email_access_token',
  PRE_BOOKING_SELECTION: 'pre_booking_selection',
}

export const googleMapLibraries = {
  GEOMETRY: 'geometry',
  DRAWING: 'drawing',
  PLACES: 'places',
}

export const sessionStorageKeys = {
  PREVIOUS_SELECTED_SLOT: 'PREVIOUS_SELECTED_SLOT',
  INSURANCE_PROVIDER_NAME: 'INSURANCE_PROVIDER_NAME',
  CURRENT_ROUTER: 'CURRENT_ROUTER',
  PREVIOUS_ROUTER: 'PREVIOUS_ROUTER',
  CONNECTION_EMAIL: 'CONNECTION_EMAIL',
  PROVIDER_SEARCH_QUERY: 'PROVIDER_SEARCH_QUERY',
  USER_EMAIL: 'USER_EMAIL',
  TIMEZONE_ABBR: 'TIMEZONE_ABBR',
  TIMEZONE_OBJ: 'TIMEZONE_OBJ',
  DISABLE_PROVIDER_FETCH_ONCE: 'DISABLE_PROVIDER_FETCH_ONCE',
  THRIVECARE_CLINICIAN_DATA: 'THRIVECARE_CLINICIAN_DATA',
  VERIFIED_INSURANCE_AUDIT_ID: 'VERIFIED_INSURANCE_AUDIT_ID',
  VERIFIED_INSURANCE_CARRIER_ID: 'VERIFIED_INSURANCE_CARRIER_ID',
}

// https://github.com/filipdanic/compact-timezone-list/blob/master/index.js
export const minimalTimezoneSet: TimeZone[] = [
  {
    offset: '-10:00',
    label: '(GMT-10:00) Hawaii Time',
    tzCode: 'Pacific/Honolulu',
    tzAbbr: 'HST',
    tzName: 'Hawaii-Aleutian Standard Time',
  },
  {
    offset: '-09:00',
    label: '(GMT-09:00) Alaska Time',
    tzCode: 'America/Anchorage',
    tzAbbr: 'AK',
    tzName: 'Alaska Standard Time',
  },
  {
    offset: '-08:00',
    label: '(GMT-08:00) Alaska Daylight Time',
    tzCode: 'America/Anchorage',
    tzAbbr: 'AKDT',
    tzName: 'Alaska Daylight Time',
  },
  {
    offset: '-08:00',
    label: '(GMT-08:00) Pacific Time',
    tzCode: 'America/Los_Angeles',
    tzAbbr: 'PST',
    tzName: 'Pacific Standard Time',
  },
  {
    offset: '-07:00',
    label: '(GMT-07:00) Pacific Daylight Time',
    tzCode: 'America/Los_Angeles',
    tzAbbr: 'PDT',
    tzName: 'Pacific Daylight Time',
  },
  {
    offset: '-07:00',
    label: '(GMT-07:00) Mountain Time',
    tzCode: 'America/Denver',
    tzAbbr: 'MST',
    tzName: 'Mountain Standard Time',
  },
  {
    offset: '-06:00',
    label: '(GMT-06:00) Mountain Daylight Time',
    tzCode: 'America/Denver',
    tzAbbr: 'MDT',
    tzName: 'Mountain Daylight Time',
  },
  {
    offset: '-07:00',
    label: '(GMT-07:00) Arizona',
    tzCode: 'America/Phoenix',
    tzAbbr: 'MST',
    tzName: 'Mountain Standard Time',
  },
  {
    offset: '-06:00',
    label: '(GMT-06:00) Central Time',
    tzCode: 'America/Chicago',
    tzAbbr: 'CT',
    tzName: 'Central Standard Time',
  },
  {
    offset: '-05:00',
    label: '(GMT-05:00) Central Daylight Time',
    tzCode: 'America/Chicago',
    tzAbbr: 'CDT',
    tzName: 'Central Daylight Time',
  },
  {
    offset: '-05:00',
    label: '(GMT-05:00) Eastern Time',
    tzCode: 'America/New_York',
    tzAbbr: 'EST',
    tzName: 'Eastern Standard Time',
  },
  {
    offset: '-04:00',
    label: '(GMT-04:00) Eastern Daylight Time',
    tzCode: 'America/New_York',
    tzAbbr: 'EDT',
    tzName: 'Eastern Daylight Time',
  },
  {
    offset: '-04:00',
    label: '(GMT-04:00) Atlantic Time - Halifax',
    tzCode: 'America/Halifax',
    tzAbbr: 'AST',
    tzName: 'Atlantic Standard Time',
  },
  {
    offset: '-03:00',
    label: '(GMT-03:00) Atlantic Daylight Time - Halifax',
    tzCode: 'America/Halifax',
    tzAbbr: 'ADT',
    tzName: 'Atlantic Daylight Time',
  },
  {
    offset: '+05:30',
    label: '(GMT+05:30) India Standard Time',
    tzCode: 'Asia/Calcutta',
    tzAbbr: 'IST',
    tzName: 'India Standard Time',
  },
]

export const invalidTimezones = ['ET']

export const LOCATION_FETCH_STATUS = {
  success: 'OK',
  empty: 'ZERO_RESULTS',
}

export const ACTIVE_THRIVEWOKS_MEMBER = 'ACTIVE THRIVEWORKS MEMBER'
export const INACTIVE_THRIVEWOKS_MEMBER = 'INACTIVE THRIVEWORKS MEMBER'
export const USER_GEO_IP_LOCATION_KEY = 'device_geo_location_name'
export const NOTE_TEXT_MAXLENGTH = 5500

export enum DashboardPageTypes {
  SESSIONS = 'sessions',
  HOME = 'home',
  FIRESIDE = 'fireside',
  ACCOUNT = 'account',
  BILLING = 'billing',
  BILLING_SESSION_DETAILS = 'session',
}
export const supportDashboardMembershipLabel = {
  activeMember: 'Active Thriveworks Member',
  inactiveMember: 'Inactive Thriveworks Member',
}

export const FIRESIDE_FEEDBACK_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSfHobBVApwUHo_C8gcTIhe3nJdwPBAbPChwHqCZbiq2EcBagg/viewform'

export enum UserTypes {
  SUPPORT = 'support',
  PATIENT = 'patient',
  AMD = 'amd',
  CLINICIAN = 'clinician',
}

export enum PaymentProvider {
  STRIPE = 'STRIPE',
  AMD_PAY = 'AMD_PAY',
}

export const practitionerTypes = {
  PROVIDER: 'provider',
  PSYCHIATRIST: 'psychiatrist',
  THERAPIST: 'therapist',
}

export const seFriendlyPractitionerTypes = {
  PROVIDERS: 'providers',
  PSYCHIATRISTS: 'psychiatrists',
  THERAPISTS: 'therapists',
}

export const PractitionerTitle = {
  NP: 'NP',
  Psych_NP: 'Psychiatry NP',
  PMHNP: 'PMHNP',
  Psych_PMHNP: 'Psychiatry PMHNP',
  DNP: 'DNP',
  DO: 'DO',
  MD: 'MD',
  PMHNP_FNP_DNP: 'PMHNP FNP DNP',
}

export const filterTitle = {
  SPECIALTY: 'Specialty',
  LOCATION: 'Location',
  SERVICE: 'Service type',
  INSURANCE: 'Insurance',
  AVAILABILITY: 'Visit type',
  TIME_OF_DAY: 'Time of day',
  PROVIDER_GENDER: 'Clinician gender',
  CLIENT_AGE: 'Client age',
  LANGUAGES: 'Language',
  COUNSELING_APPROACH: 'Counseling approach',
  SORT_BY: 'Sort By',
  B2B_CLIENT: 'Partnership client',
}

export const blackListedRoutesForPageView: string[] = [
  pageRoutes.BOOKING,
  catchAllPageRoutes.DASHBOARD_USER,
  catchAllPageRoutes.DASHBOARD_FIRESIDE,
]

/** Specifies keys that are sent in query when Book Session
 * is clicked for a specific patient in the support dashboard */
export const supportDashboardToProviderSearchKeys = ['userId', 'patients']

export enum HttpStatusCode {
  SUCCESS = 200,
  PAGE_NOT_FOUND = 404,
}

export enum BreakPoints {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XLG = 'xlg',
  XXL = 'xxl',
  CB = 'custom-breakpoint',
}

export enum AppointmentStatus {
  BOOKED = 'booked',
  CANCELLED = 'cancelled',
}

export enum BookingFlows {
  PATIENT_REBOOKING_MODAL = 'Patient Rebooking Modal',
  SUPPORT_REBOOKING_MODAL = 'Support Rebooking Modal',
  PATIENT_STANDARD_FUNNEL = 'Patient Standard Funnel',
  SUPPORT_STANDARD_FUNNEL = 'Support Standard Funnel',
}

export const GENERIC_SUPPORT_PHONE_NUM = '8552847483'

export enum Env {
  MAIN = 'main',
  STAGING = 'staging',
  QA = 'qa',
  DEV = 'default',
}

export const RP_NOT_CREATED_ERROR = 'Responsible party was not created'

export enum ApiStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export const providerSearchNumber = {
  formattedPhoneNumber: '(833) 966-4291',
  phoneNumber: '8339664291',
}

export const providerProfileNumber = {
  formattedPhoneNumber: '(855) 209-3255',
  phoneNumber: '8552093255',
}

export const providerProfileNumberWithCode = '+1-855-209-3255'

export const bookingToolNumber = {
  formattedPhoneNumber: '(855) 209-3256',
  phoneNumber: '8552093256',
}

export const bookingToolNumberForPartners = [
  {
    formattedPhoneNumber: '(855) 392-1440',
    phoneNumber: '8553921440',
    partnershipCode: 'C-227-PCP CHARLIE',
  },
  {
    formattedPhoneNumber: '(888) 417-5691',
    phoneNumber: '8884175691',
    partnershipCode: 'C-110-B2 QUARTET HEA',
  },
  {
    formattedPhoneNumber: '(855) 205-9986',
    phoneNumber: '8552059986',
    partnershipCode: 'C-217-B2 IBC PA',
  },
  {
    formattedPhoneNumber: '(617) 263-8059',
    phoneNumber: '6172638059',
    partnershipCode: 'C-120-B2 BCBS OF MA',
  },
  {
    formattedPhoneNumber: '(855) 994-0175',
    phoneNumber: '8559940175',
    partnershipCode: 'C-456-PCP ELEANOR',
  },
]

export const searchNumber = {
  formattedPhoneNumber: '(855) 208-5153',
  phoneNumber: '8552085153',
}

export enum RudderstackIntegrations {
  GOOGLE_ADS = 'Google Ads',
  GOOGLE_TAG_MANAGER = 'Google Tag Manager',
  FACEBOOK_PIXEL = 'Facebook Pixel',
}

export const SLOTS_ROW_LIMIT = 5
export const SLOTS_ROW_LIMIT_V3 = 4
// to handle sad path slots row
// https://www.figma.com/file/cUU4v0VbIgs61qdEY7sv1o/Search-%2B-Profile---Exploration?type=design&node-id=6633-20193&mode=design&t=8GdryxU9H9EFrMOk-0
export const SAD_PATH_SLOTS_ROW_LIMIT = 3

export const NAVBAR_NORMAL_HEIGHT = 139
export const NAVBAR_BIG_HEIGHT = 210

export const BOOKING_FLOW_CHANGE_SLOT_MODAL_SLOT_LIMIT = 21

export enum TimeOfDay {
  EARLY_MORNING = 'early_morning',
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
}

export const timeOfDayDescription = {
  early_morning: 'before 9am',
  morning: '9am - noon',
  afternoon: 'noon - 5pm',
  evening: 'after 5pm',
}

export const DEFAULT_DEBOUNCE_WAIT = 600

export const CTA_CLASSES = {
  viewAllAvailability:
    'pp-btn provider-profile-page-view-all-availability-cta sticky-schedule-section',
  callUs: 'pp-btn provider-profile-page-call-btn-cta sticky-schedule-section',
  moreProviders:
    'pp-btn provider-profile-page-book-btn-cta providers-available-lower-section',
}
